import React from 'react';
import './OrderCard.css';

const OrderCardSkeleton = () => {
  return (
    <div className="order-row skeleton-card">
      <div className="order-row-inner">
        <div className="skeleton-row-inner">
          {/* Thumbnail Skeleton */}
          <div className="skeleton-thumb skeleton-shimmer"></div>

          {/* Info Skeleton */}
          <div className="skeleton-info">
            <div className="skeleton-id skeleton-shimmer"></div>
            <div className="skeleton-name skeleton-shimmer"></div>
            <div className="skeleton-meta skeleton-shimmer"></div>
          </div>

          {/* Price Skeleton */}
          <div className="skeleton-price skeleton-shimmer"></div>

          {/* Hash Skeleton - Hidden on mobile */}
          <div className="skeleton-hash skeleton-shimmer" style={{ display: window.innerWidth > 1024 ? 'block' : 'none' }}></div>

          {/* Button Skeleton */}
          <div className="skeleton-button skeleton-shimmer"></div>
        </div>
      </div>
    </div>
  );
};

export default OrderCardSkeleton;
